import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import './CardRail.css';

import online from '../../assets/images/Online.png';
import mobile from '../../assets/images/Mobile.png';
import savings from '../../assets/images/saving.png';
import Personal from '../../assets/images/PersonalBanking.jpg';

const items = [
  {
    title: 'Get paid early',
    desc: 'Set up direct deposit and get your paycheck up to 2 days sooner.',
    image: mobile,
    cta: { label: 'Set up direct deposit', href: '/DirectDeposit' },
  },
  {
    title: 'No monthly fees',
    desc: 'Banking with no monthly fees and straightforward features.',
    image: Personal,
    cta: { label: 'See checking', href: '/checking' },
  },
  {
    title: 'High‑yield savings',
    desc: 'Grow your money automatically with round‑ups and transfers.',
    image: savings,
    cta: { label: 'Explore savings', href: '/savings' },
  },
  {
    title: 'Online & Mobile',
    desc: 'Pay bills, transfer, and manage money anytime, anywhere.',
    image: online,
    cta: { label: 'Online banking', href: '/OnlineBanking' },
  },
];

const CardRail = () => {
  return (
    <section className="card-rail section">
      <div className="gn-container">
        <Swiper
          modules={[Autoplay, FreeMode]}
          spaceBetween={16}
          slidesPerView="auto"
          freeMode={{ enabled: true, momentum: false }}
          loop
          speed={7000}
          autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }}
          allowTouchMove={false}
        >
          {items.concat(items).map((item, idx) => (
            <SwiperSlide key={idx} className="rail-slide">
              <a className="rail-card" href={item.cta.href}>
                <div className="rail-media">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="rail-body">
                  <h3 className="rail-title">{item.title}</h3>
                  <p className="rail-desc">{item.desc}</p>
                  <span className="rail-cta">{item.cta.label} →</span>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default CardRail;


